var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { staticClass: "pledge-selector" },
    [
      _c(
        "Box",
        {
          attrs: {
            tag: "header",
            display: "flex",
            flexAalign: "center",
            marginBottom: 4
          }
        },
        [
          _c("layoutText", { attrs: { fontSize: 2, fontWeight: "bold" } }, [
            _vm._v("Pledges")
          ]),
          _c(
            "UIButton",
            {
              staticClass: "smaller inverted btn",
              attrs: { type: "button" },
              on: { click: _vm.addNewPledge }
            },
            [_vm._v("+ add new pledge")]
          )
        ],
        1
      ),
      _c(
        "Box",
        { staticClass: "pledges" },
        _vm._l(_vm.pledgesCopy, function(pledge) {
          return _c("singlePledge", {
            key: pledge.tmpIndex,
            attrs: { pledge: pledge, donorId: _vm.donorId }
          })
        }),
        1
      ),
      _vm.errorStr
        ? _c("span", { staticClass: "error-label" }, [
            _vm._v(_vm._s(_vm.errorStr))
          ])
        : _vm._e(),
      _vm.getPledgesCopy().length < _vm.pledges.length
        ? _c("span", [
            _vm._v("This donor has other pledges in different currencies")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }